































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Route } from "vue-router";
import { Dictionary } from "vue-router/types/router";
import { Form as ElForm, Input } from "element-ui";
import { UserModule } from "@/store/modules/user";
import { isValidUsername } from "@/utils/validate";
import { login, logout } from "@/api/users";
import { addtopic } from "@/api/declare";
@Component({
  name: "Login",
})
export default class extends Vue {
  private imgurl = require("@/assets/loginimage/logo1@2x.png");

  private validateUsername = (rule: any, value: string, callback: Function) => {
    if (value === "") {
      callback(new Error("请输入用户名"));
    } else {
      callback();
    }
  };
  private validatePassword = (rule: any, value: string, callback: Function) => {
    if (value.length === 0) {
      callback(new Error("请输入密码"));
    } else {
      callback();
    }
  };
  private loginForm = {
    loginname: "",
    password: "",
  };
  private loginRules = {
    loginname: [{ validator: this.validateUsername, trigger: "blur" }],
    password: [{ validator: this.validatePassword, trigger: "blur" }],
  };
  private passwordType = "password";
  private loading = false;
  private showDialog = false;
  private redirect?: string;
  private otherQuery: Dictionary<string> = {};

  @Watch("$route", { immediate: true })
  private onRouteChange(route: Route) {
    const query = route.query as Dictionary<string>;
    if (query) {
      this.redirect = query.redirect;
      this.otherQuery = this.getOtherQuery(query);
    }
  }

  mounted() {
    // if (this.loginForm.loginname === "") {
    //   // (this.$refs.loginname as Input).focus();
    // } else if (this.loginForm.password === "") {
    //   // (this.$refs.password as Input).focus();
    // }
  }

  private showPwd() {
    if (this.passwordType === "password") {
      this.passwordType = "";
    } else {
      this.passwordType = "password";
    }
    this.$nextTick(() => {
      (this.$refs.password as Input).focus();
    });
  }
  private hrefopen() {
    window.open("http://www.tellyes.com/");
  }
  private handleLogin() {
    (this.$refs.loginForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        // await UserModule.Login(this.loginForm);
        const param = {
          loginName: this.loginForm.loginname,
          pwd: this.loginForm.password,
          role: 1,
        };
        await login(param).then((res) => {
          if (res.code === 200) {
            let json = {
              data: res.data,
            };
            let islogin = {
              islogin: true,
            };
            window.sessionStorage.setItem("json", JSON.stringify(json));
            window.sessionStorage.setItem("islogin", JSON.stringify(islogin));
            let addparam = {
              userId: res.data.id,
            };
            this.$router.push({ path: "/tissuemanage/tissuemanage" });

            // 用户组织id为空，游客登录  用户组织不为空，管理员登录
          } else if (res.code === 205) {
            this.$message.warning("当前用户没有登录权限");
          } else if (res.code === 204) {
            this.$message.warning(
              "您的账户尚未激活，请等待管理员进行激活后再登录系统"
            );
          } else {
            this.$message.warning("登录错误,请确认用户名和密码");
          }
        });
        setTimeout(() => {
          this.loading = false;
        }, 0.5 * 1000);
      } else {
        return false;
      }
    });
  }
  private handleRegister() {
    let islogin = {
      islogin: false,
    };
    this.$router.push({ path: "/register/register" });
    window.sessionStorage.setItem("islogin", JSON.stringify(islogin));
  }
  private getOtherQuery(query: Dictionary<string>) {
    return Object.keys(query).reduce((acc, cur) => {
      if (cur !== "redirect") {
        acc[cur] = query[cur];
      }
      return acc;
    }, {} as Dictionary<string>);
  }
}
